import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Col, Row} from "reactstrap";

import { metadataService, AccountAPI } from "../../_services";
import { SlButton } from "../editors";
import { MfaCodeEntry } from "../editors/MfaCodeEntry";

export class MfaValidation extends Component {

  constructor(props) {
    

    super(props);
    
    this.state = {
      currentStep: 0,
      mfaCode: ['',''],
      mfaSentMessage: "",
      mfaToken: "", 
      mfaError:"",
      isLoading : false,
    };
    
    this.mfaValueUpdated = this.mfaValueUpdated.bind(this);
    this.confirmSendMfaMessage = this.confirmSendMfaMessage.bind(this);
    this.validateMfaCode = this.validateMfaCode.bind(this);
  }
  confirmSendMfaMessage() {
    //Send the confirmation
    this.setState({isLoading: true});
    switch(this.props.mode)
    {
      case "email":
          AccountAPI.sendMfaCodeToUserEmail(this.props.mfaReason).then(response => {
            this.setState({mfaToken: response.data.tokenId, mfaSentMessage: response.message
            });
          }).finally(() => this.setState({isLoading : false}));     
        break; 
        case "phone": 
            AccountAPI.sendMfaCodeToUserText(this.props.mfaReason).then(response => {
          this.setState({mfaToken: response.data.tokenId, mfaSentMessage: response.message});
        }).finally(() => this.setState({isLoading : false}));
        break; 
      default: 
        //Mobile OptIn. 
        AccountAPI.sendMfaCodeToText(this.props.mfaReason, this.props.mobileNumber).then(response => {
          this.setState({mfaToken: response.data.tokenId, mfaSentMessage: response.message});
        }).finally(() => this.setState({isLoading : false}));

    }
  }
  mfaValueUpdated(newMfaValue){
      this.setState({mfaCode:newMfaValue});
  }

  validateMfaCode()
  {
      this.setState({isLoading: true});
      if(this.props.mode === "optin"){
        AccountAPI.validateMfaCodeAnon(this.state.mfaToken, this.state.mfaCode, this.props.mfaReason)
          .then(
              response => {
                  if(response.status <= 1 && response.data){
                      this.props.mfaConfirmed(this.state.mfaToken);
                  }
                  else{
                    console.log("ERROR MESSAGE: " + response.message)
                      this.setState({mfaError:response.message});
                  }
              }
          ).finally(() => this.setState({isLoading : false}))
      }
      else{
        AccountAPI.validateMfaCode(this.state.mfaToken, this.state.mfaCode, this.props.mfaReason)
          .then(
              response => {
                  if(response.status <= 1){
                      this.props.mfaConfirmed(this.state.mfaToken);
                  }
                  else{
                      console.log("ERROR MESSAGE: " + response.message)
                      this.setState({mfaError:metadataService.getMessage("MfaCodeFailed")});
                  }
              }
          ).finally(() => this.setState({isLoading : false}))
      }
  }
  render() {
    if (this.state.mfaToken === "") {
      //Get Token
      return (
        <React.Fragment>
          <Row className="justify-content-center m-3 p-3">
            <Col xs={12} md={8}>
              {this.props.mode === 'email' && metadataService.getMessage("MfaWillConfirmEmail")}
              {this.props.mode === 'phone' && metadataService.getMessage("MfaWillConfirmPhone")}
              {this.props.mode === 'optin' && metadataService.getMessage("MobileOptIn")}
            </Col>
          </Row>
          <Row className="justify-content-center">
              <SlButton size="lg" name="Next" disabled={this.state.isLoading} onClick={this.confirmSendMfaMessage} />
          </Row>
        </React.Fragment>
      );
    } // Validate Token
    else {
      return (
        <React.Fragment>
          <MfaCodeEntry message={this.state.mfaSentMessage} value={this.state.mfaCode} 
            valueUpdated={this.mfaValueUpdated} disabled={this.state.isLoading} onSubmit={this.validateMfaCode} error={this.state.mfaError}/>
          
          
          </React.Fragment>
      );
    }
  }


}
MfaValidation.propTypes = {
    mfaConfirmed: PropTypes.func.isRequired, 
    mode: PropTypes.string.isRequired, 
    mobileNumber: PropTypes.string , 
    mfaReason: PropTypes.number.isRequired,
    language: PropTypes.string
}